import { lazy, Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import Home from '@/app/page';


const MediaPage = lazy(() => import('@/app/media/page'));
const TalkWithMePage = lazy(() => import('@/app/talk-with-me/page'));
const CalculatorDashboard = lazy(() => import('@/app/investment-calculators/page'));
const CalculatorClient = lazy(() => import('@/app/investment-calculators/[slug]/CalculatorClient'));
const AdminDashboard = lazy(() => import('@/app/admin/page'));
const DisclaimerPage = lazy(() => import('@/app/disclaimer/page'));
const PrivacyPolicyPage = lazy(() => import('@/app/privacy-policy/page'));
const RefundPolicyPage = lazy(() => import('@/app/refund-policy/page'));
const TermsAndConditionsPage = lazy(() => import('@/app/terms-and-conditions/page'));

function CalculatorRoute() {
  const { slug = '' } = useParams();
  return <CalculatorClient key={slug} slug={slug} />;
}

function RouteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    document.title = 'Madurai Veeran Money Coach';
  }, [location.pathname]);

  return null;
}

export default function App() {
  const isAdminSubdomain = typeof window !== 'undefined' && window.location.hostname.startsWith('admin.');

  return (
    <>
      <RouteEffects />
      <Suspense fallback={<div style={{ minHeight: '100vh', background: '#fff' }} aria-label="Loading page" />}>
        <Routes>
          <Route path="/" element={isAdminSubdomain ? <AdminDashboard /> : <Home />} />

          <Route path="/media" element={<MediaPage />} />
          <Route path="/talk-with-me" element={<TalkWithMePage />} />
          <Route path="/investment-calculators" element={<CalculatorDashboard />} />
          <Route path="/investment-calculators/:slug" element={<CalculatorRoute />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  );
}
